/**
 * Google "Continue with Google" button.
 *
 * Hits the backend /api/auth/google/start with a full top-level navigation
 * (NOT axios) so the browser receives the 302 to Google.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
 * THIS BREAKS THE AUTH. We rely on the backend honoring X-Forwarded-Proto
 * to build the callback URL from the actual request host.
 */
import React from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function GoogleButton({ referralCode, next = "/", label = "Continue with Google" }) {
  const handleClick = () => {
    const params = new URLSearchParams();
    if (next) params.set("next", next);
    if (referralCode) params.set("ref", referralCode);
    window.location.href = `${BACKEND}/api/auth/google/start?${params.toString()}`;
  };
  return (
    <button
      type="button"
      onClick={handleClick}
      className="hud-btn w-full justify-center bg-[hsl(var(--surface))] hover:bg-[hsl(var(--surface-hover))]"
      data-testid="google-signin-button"
    >
      <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden>
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/>
        <path fill="#FBBC05" d="M5.84 14.1A6.6 6.6 0 0 1 5.5 12c0-.73.13-1.44.34-2.1V7.07H2.18A11 11 0 0 0 1 12c0 1.77.42 3.45 1.18 4.93l3.66-2.83z"/>
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.07.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.83C6.71 7.31 9.14 5.38 12 5.38z"/>
      </svg>
      {label}
    </button>
  );
}
